import { createContext, ReactNode } from 'react';
import { ModalConfig } from './types';

export type ModalContextInstance = {
  isOpen: boolean,
  template: ReactNode,
  open: (config: ModalConfig) => void,
  close: () => void,
};

export const ModalContext = createContext<ModalContextInstance>({
  isOpen: false,
  template: null,
  open: () => null,
  close: () => null,
});
